import UUIDBase from './UUIDBase'
import Customer from './customer/Customer'
import Pet, { PetCustomer } from './Pet'
import type { User } from './user/User'
import Appointment from './customer/Appointment'
import type Item from './inventory/Item'
import type Category from './inventory/Category'

export const vetServiceI18nMessages = {
  en: {
    vetServices: 'Vet Services',
    vetService: 'Vet Service',
    newVetService: 'New Vet Service',
    editVetService: 'Edit Vet Service',
    viewVetService: 'View Vet Service',
    pet: 'Pet',
    petName: 'Pet Name',
    type: 'Type',
    customer: 'Customer',
    vet: 'Vet',
    services: 'Services',
    addService: 'Add Service',
    category: 'Category',
    service: 'Service',
    notes: 'Notes',
    internalNotes: 'Internal Notes',
    nextAppointment: 'Next Appointment',
    contacted: 'Contacted',
    selectPet: 'Select Pet',
    selectVet: 'Select Vet',
    petInfo: 'Pet Information',
    serviceInfo: 'Service Information',
    sex: 'Sex',
    male: 'Male',
    female: 'Female',
    price: 'Price'
  },
  ar: {
    vetServices: 'خدمات بيطرية',
    vetService: 'خدمة بيطرية',
    newVetService: 'خدمة بيطرية جديدة',
    editVetService: 'تعديل خدمة بيطرية',
    viewVetService: 'عرض خدمة بيطرية',
    pet: 'الأليف',
    petName: 'اسم الأليف',
    type: 'النوع',
    customer: 'الزبون',
    vet: 'الطبيب البيطري',
    services: 'الخدمات',
    addService: 'إضافة خدمة',
    category: 'الفئة',
    service: 'الخدمة',
    notes: 'ملاحظات',
    internalNotes: 'ملاحظات داخلية',
    nextAppointment: 'الموعد القادم',
    contacted: 'تم التواصل',
    selectPet: 'اختر الأليف',
    selectVet: 'اختر الطبيب البيطري',
    petInfo: 'معلومات الأليف',
    serviceInfo: 'معلومات الخدمة',
    sex: 'الجنس',
    male: 'ذكر',
    female: 'انثى',
    price: 'السعر'
  }
}

export interface VetServiceItem {
  id: string
  itemCategoryID?: string
  itemID?: string
  price?: number
  priceType?: string
  notes?: string
  internalNotes?: string
}

export interface VetServiceExtraProperties {
  services: VetServiceItem[]
}

export interface VetServicesPaginated {
  data: Array<VetService>
  total: number
}

export default class VetService extends UUIDBase {
  static from(json: Record<string, unknown> | VetService) {
    return Object.assign(new VetService(), json)
  }
  static ENDPOINT = '/customer/vet-services'

  customerID = ''
  customer: Customer | PetCustomer | null = null

  petID = ''
  pet: Pet | null = null

  userID = ''
  user: User | null = null

  vetID = ''
  vet: User | null = null

  appointments: Appointment[] = []

  notes = ''
  internalNotes = ''
  contacted = false

  extraProperties: VetServiceExtraProperties = {
    services: []
  }

  // Items and categories arrays for lookup optimization - populated from backend
  items: Item[] = []
  itemCategories: Category[] = []

  get customerName() {
    if (this.customer && 'name' in this.customer) {
      return this.customer.name
    }
    return ''
  }

  get petName() {
    return this.pet?.name || ''
  }

  get vetName() {
    if (this.vet && 'name' in this.vet) {
      return this.vet.name
    }
    return ''
  }
}
